<script setup>
import LoadingOverlay from '@/Components/LoadingOverlay.vue';
import CookieConstent from '@/Components/CookieConstent.vue';
import FooterComponent from '@/Components/Frontend/Common/FooterComponent.vue';
import NavbarComponent from '@/Components/Frontend/Common/NavbarComponent.vue';
// import NavbarV2Component from '@/Components/Frontend/Common/NavbarV2Component.vue';
import PhoneComponent from '@/Components/Frontend/Common/PhoneComponent.vue';
import PageScrollComponent from '@/Components/Frontend/Common/PageScrollComponent.vue';
import { Link } from '@inertiajs/vue3';
import { onMounted } from 'vue'
import { initFlowbite } from 'flowbite'
import { ref } from 'vue';
onMounted(() => {
    initFlowbite();
})

</script>

<template>

    <div>
        <loading-overlay />
        <navbar-component />
        <!-- <NavbarV2Component/> -->
        <slot />
    </div>
    <footer-component />
    <page-scroll-component />
    <PhoneComponent />
    <cookie-constent />
</template>

<style></style>
